import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { capitalize } from "@mui/material";
import { SendPostRequest } from "../../http";
import Captcha from "../Captcha/Captcha";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";

function AppointmentDoctor() {
  const sitedata = useSelector((store) => store.global.loginData);
  const patientLogin = useSelector((state) => state.patient.patientLogin);
  const todayDate = new Date().toISOString().split("T")[0];

  const [inputValues, setInputValues] = useState({});
  const [shift, setShift] = useState(null);
  const [selectedHospital, setSelectedHospital] = useState(null);
  const [hospitals, setHospitals] = useState([]);

  const [hospitalSlots, setHospitalSlots] = useState([]);
  const [displayedValue, setDisplayedValue] = useState(null);

  useEffect(() => {
    if (patientLogin) {
      setInputValues({
        patient_name: patientLogin?.fullname,
        email: patientLogin?.email,
        contact_number: patientLogin?.contact_num,
      });
    }
    window.scrollTo(0, 0);
    handleRefresh();
    fetchHospitals();
  }, []);

  // Fetch hospitals list
  const fetchHospitals = async () => {
    try {
      const response = await SendPostRequest("doctors/schedule");
      const hospitalsData = response?.data?.hospitals || [];
      setHospitals(hospitalsData);

      // Set initial hospital if available
      if (hospitalsData.length > 0) {
        setSelectedHospital({
          label: hospitalsData[0].info.title,
          value: hospitalsData[0]
        });
      }
    } catch (error) {
      console.error("Error fetching hospitals:", error);
    }
  };

  useEffect(() => {
    const getHospitalSlots = async () => {
      const date = inputValues.appointment_date;
      const type = sitedata.site_type;
      let allInputs;

      try {
        allInputs = {
          type,
          doct_uid: sitedata.site_id,
          date,
          clinic_id: selectedHospital?.value?.info?.uid // Include hospital ID
        };
        if (date) {
          const res = await SendPostRequest("hospitals/slots", allInputs);
          setHospitalSlots(res.data);
        }
      } catch (error) {
        console.error("Error fetching doctor's slots:", error);
      }
    };
    getHospitalSlots();
  }, [inputValues.appointment_date, selectedHospital]);

  const reasonOptions = [
    { value: "son-of", label: "Son Of" },
    { value: "daughter-of", label: "Daughter Of" },
    { value: "father-of", label: "Father Of" },
    { value: "mother-of", label: "Mother Of" },
    { value: "husband-of", label: "Husband Of" },
    { value: "wife-of", label: "Wife Of" },
  ];

  const [shiftOptions, setShiftOptions] = useState([]);

  useEffect(() => {
    const newShiftOptions = [];

    if (
      Object.keys(hospitalSlots).length === 0 &&
      inputValues.appointment_date
    ) {
      newShiftOptions.push({ value: "morning", label: "Morning" });
      newShiftOptions.push({ value: "evening", label: "Evening" });
    } else {
      for (const key in hospitalSlots) {
        if (hospitalSlots.hasOwnProperty(key)) {
          newShiftOptions.push({ value: key, label: hospitalSlots[key] });
        }
      }
    }

    setShiftOptions(newShiftOptions);
    setDisplayedValue(null);
  }, [hospitalSlots]);

  const handleHospitalChange = (selectedOption) => {
    setSelectedHospital(selectedOption);
    setShift(null);
    setDisplayedValue(null);
  };


  const handleShiftChange = (selectedOption) => {
    setShift(selectedOption.value);
    setDisplayedValue(selectedOption?.label);
  };

  const [captcha, setCaptcha] = useState("");
  const [input_captcha, setInputCaptcha] = useState("");
  const [check_captcha, setCheckCaptcha] = useState("");
  const [appointmentisLoading, setAppointmentisLoading] = useState(false);

  const formatDate = (inputDate) => {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1;
    const day = dateObject.getDate();
    const formattedDate = `${year}-${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day
      }`;

    return formattedDate;
  };

  const handleContactNumber = (e) => {
    let val = e.target.value;
    if (val.length <= 14) {
      setInputValues((prevValues) => ({
        ...prevValues,
        contact_number: val,
      }));
    }
    return;
  };

  const handleAllInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "appointment_date") {
      const formattedDate = formatDate(value);
      setInputValues((prevValues) => ({
        ...prevValues,
        appointment_date: formattedDate,
      }));
    } else {
      setInputValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }));
    }
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    setAppointmentisLoading(true);

    if (!inputValues.patient_name) {
      toast.error("Enter patient name");
      setAppointmentisLoading(false);
      return;
    } else if (!inputValues.contact_number) {
      toast.error("Enter Number");
      setAppointmentisLoading(false);
      return;
    } else if (
      inputValues.contact_number.length > 14 ||
      inputValues.contact_number.length < 10
    ) {
      toast.error("Invalid Number");
      setAppointmentisLoading(false);
      return;
    } else if (!inputValues.appointment_date) {
      toast.error("Enter Date");
      setAppointmentisLoading(false);
      return;
    } else if (!selectedHospital) {
      toast.error("Select Hospital");
      setAppointmentisLoading(false);
      return;
    } else if (!shift) {
      toast.error("Select Your Shift");
      setAppointmentisLoading(false);
      return;
    } else if (captcha === input_captcha) {
      setCheckCaptcha("Captcha Verified");
    } else {
      setCheckCaptcha("Captcha failed");
      setAppointmentisLoading(false);
    }

    if (captcha === input_captcha) {
      try {
        const myallInputs = {
          ...inputValues,
          doctor_id: sitedata.site_id,
          shift,
          hospital_id: selectedHospital.value.info.uid // Include hospital ID in submission
        };

        const response = await SendPostRequest(
          "doctors/appointment_form",
          myallInputs
        );
        if (response.status === "success") {
          setInputValues({
            patient_name: patientLogin ? patientLogin.fullname : "",
            email: patientLogin ? patientLogin.email : "",
            contact_number: patientLogin ? patientLogin.contact_num : "",
            // age: "",
            appointment_date: "",
            remarks: "",
          });
          setDisplayedValue(null);
          setInputCaptcha("");
          setCheckCaptcha("");
          setShift(null);
          handleRefresh();
        }

        toast.success(response.message);

        setAppointmentisLoading(false);
      } catch (e) {
        toast.error("Something Went Wrong");
        setAppointmentisLoading(false);
      }
    } else {
      setCheckCaptcha("Captcha failed");
      toast.error("Captcha verification failed");
      setAppointmentisLoading(false);
    }
  };

  const textColorClass =
    check_captcha === "Captcha Verified" ? "text-success" : "text-danger";

  const handleInputChange = (e) => {
    setInputCaptcha(e.target.value);
  };

  const handleRefresh = () => {
    const newCaptcha = generateRandomCaptcha();
    setCaptcha(newCaptcha);
  };

  const generateRandomCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const captchaLength = 6;
    let newCaptcha = "";

    for (let i = 0; i < captchaLength; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      newCaptcha += characters.charAt(randomIndex);
    }

    return newCaptcha;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      formSubmit(e);
    }
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />
        <TextMainBannerWrapper Heading="Appointment" Image="theme-2-banner-appointment.webp" />
        {/* <div className="page-title-wrap typo-white">
          <div
            className="page-title-wrap-inner section-bg-img"
            style={{
              backgroundImage: "url(/assets/images/bg/page-title-bg.jpg)",
            }}
          >
            <span className="black-overlay"></span>
            <div className="container">
              <div className="row text-left">
                <div className="col-md-12">
                  <div className="page-title-inner">
                    <h1 className="page-title mb-0">Appointment</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {
          sitedata?.theme_appointment_form === "colored" ? (
            <div className="pt-4" style={{ background: "#000" }}>
              <div className="container mt-4">
                <div className="contact-form" data-animation="fadeInLeft" onKeyDown={handleKeyDown}>
                  <div className="row py-4">
                    <div className="col-lg-6 mb-3 color-form-inputs">
                      <label className="form-label">
                        Patient Name <span className="asterisk">*</span>
                      </label>
                      <input
                        name="patient_name"
                        value={inputValues.patient_name}
                        type="text"
                        className="input-name form-control"
                        placeholder="Enter Name"
                        onChange={handleAllInputChange}
                      />
                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>
                    {isMobile ? (
                      <div className="col-lg-6 mb-3 color-form-inputs">
                        <label className="form-label">
                          Contact Number <span className="asterisk">*</span>
                        </label>
                        <input
                          name="contact_number"
                          value={inputValues.contact_number}
                          type="text"
                          className="input-name form-control"
                          placeholder="Enter Contact Number"
                          onChange={handleContactNumber}
                          maxLength={14}
                          minLength={10}
                        />

                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>
                    ) : null}
                    <div className="col-lg-6 mb-3 color-form-inputs">
                      <label className="form-label">
                        Preferred Date <span className="asterisk">*</span>
                      </label>
                      <div className="cs_with_icon_input">
                        <input
                          name="appointment_date"
                          value={inputValues.appointment_date}
                          type="date"
                          className="appointment_date_input colred-date-input-icon"
                          id="datepicker"
                          placeholder="August 24, 2023"
                          onChange={handleAllInputChange}
                          min={todayDate}
                        />
                      </div>
                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>

                    {!isMobile ? (
                      <div className="col-lg-6 mb-3 color-form-inputs">
                        <label className="form-label">
                          Contact Number <span className="asterisk">*</span>
                        </label>
                        <input
                          name="contact_number"
                          value={inputValues.contact_number}
                          type="text"
                          className="input-name form-control"
                          placeholder="Enter Contact Number"
                          onChange={handleContactNumber}
                          maxLength={14}
                          minLength={10}
                        />

                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>
                    ) : null}


                    <div className="col-lg-6 mb-3 color-form-select">
                      <label className="form-label">
                        Preferred Time <span className="asterisk">*</span>
                      </label>
                      <Select
                        className="theme-2-gender-select"
                        value={
                          displayedValue !== null
                            ? { value: shift, label: displayedValue }
                            : null
                        }
                        options={shiftOptions}
                        onChange={handleShiftChange}
                        placeholder={
                          inputValues?.appointment_date
                            ? "Select Shift"
                            : "Please Select Date First"
                        }
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                          singleValue: (base) => ({
                            ...base,
                            color: "white", // selected text white rahega
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "white", // placeholder bhi white ho
                          }),
                          input: (base) => ({
                            ...base,
                            color: "white", // typing ke time bhi white ho
                          }),
                          option: (base) => ({
                            ...base,
                            color: "black", // keep options readable (default)
                          }),
                        }}
                      />
                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>


                    {hospitals.length > 1 && (
                      <div className="col-lg-6 mb-3">
                        <div className="color-form-inputs">
                          <label className="form-label">Email</label>
                          <input
                            name="email"
                            value={inputValues.email}
                            type="email"
                            className="input-name form-control"
                            placeholder="Enter your email"
                            onChange={handleAllInputChange}
                          />
                          <div className="cs_height_42 cs_height_xl_25"></div>
                        </div>
                        <div className="color-form-select mt-4">
                          <label className="form-label text-white">
                            Hospital/Clinic <span className="asterisk">*</span>
                          </label>
                          <Select
                            className="theme-2-gender-select"
                            value={selectedHospital}
                            options={hospitals.map(hospital => ({
                              label: hospital?.info?.title,
                              value: hospital
                            }))}
                            onChange={handleHospitalChange}
                            placeholder="Select Hospital"
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: base => ({ ...base, zIndex: 9999 }),
                              singleValue: (base) => ({
                                ...base,
                                color: "white", // selected text white rahega
                              }),
                              placeholder: (base) => ({
                                ...base,
                                color: "white", // placeholder bhi white ho
                              }),
                              input: (base) => ({
                                ...base,
                                color: "white", // typing ke time bhi white ho
                              }),
                              option: (base) => ({
                                ...base,
                                color: "black", // keep options readable (default)
                              }),
                            }}
                          />
                          <div className="cs_height_42 cs_height_xl_25"></div>


                        </div>

                      </div>
                    )}



                    <div className="col-lg-6 appointment-textarea mb-3 color-form-inputs">
                      <label className="form-label">Remarks</label>
                      <textarea
                        rows={6}
                        name="remarks"
                        value={inputValues.remarks}
                        type="number"
                        className="input-name form-control"
                        placeholder="Write Your remarks here"
                        onChange={handleAllInputChange}
                      ></textarea>
                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>


                    {/* <div className="col-lg-6 mb-3 color-form-inputs">
                      <label className="form-label">Age</label>
                      <input
                        name="age"
                        value={inputValues.age}
                        type="number"
                        className="input-name form-control"
                        placeholder="Enter Age"
                        onChange={handleAllInputChange}
                      />
                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div> */}

                    <div className="col-lg-6 appointment_form_capcha mb-3 color-form-inputs">
                      <label className="form-label">Captcha</label>
                      <Captcha
                        captcha={captcha}
                        inputCaptcha={input_captcha}
                        textColorClass={textColorClass}
                        checkCaptcha={check_captcha}
                        handleInputChange={handleInputChange}
                      />
                    </div>



                    <div className="col-lg-6 mb-3 mb-3">
                      <div className="cs_height_18"></div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label className="form-label" style={{ visibility: "hidden" }}>Submit Button</label>
                        <button
                          type="submit"
                          className="btn btn-default"
                          style={{ width: "100px" }}
                          onClick={formSubmit}
                          disabled={appointmentisLoading}
                        >
                          <span>
                            {appointmentisLoading ? "Please Wait" : "Submit "}
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="container mt-4">
              <div className="contact-form" data-animation="fadeInLeft" onKeyDown={handleKeyDown}>
                <div className="row py-4">
                  <div className="col-lg-6 mb-3 light-inputs-wrapper">
                    <label className="form-label">
                      Patient Name <span className="asterisk">*</span>
                    </label>
                    <input
                      name="patient_name"
                      value={inputValues.patient_name}
                      type="text"
                      className="input-name form-control"
                      placeholder="Enter Name"
                      onChange={handleAllInputChange}
                    />
                    <div className="cs_height_42 cs_height_xl_25"></div>
                  </div>
                  {isMobile ? (
                    <div className="col-lg-6 mb-3 light-inputs-wrapper">
                      <label className="form-label">
                        Contact Number <span className="asterisk">*</span>
                      </label>
                      <input
                        name="contact_number"
                        value={inputValues.contact_number}
                        type="text"
                        className="input-name form-control"
                        placeholder="Enter Contact Number"
                        onChange={handleContactNumber}
                        maxLength={14}
                        minLength={10}
                      />

                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>
                  ) : null}
                  <div className="col-lg-6 mb-3 light-inputs-wrapper">
                    <label className="form-label">
                      Preferred Date <span className="asterisk">*</span>
                    </label>
                    <div className="cs_with_icon_input">
                      <input
                        name="appointment_date"
                        value={inputValues.appointment_date}
                        type="date"
                        className="appointment_date_input"
                        id="datepicker"
                        placeholder="August 24, 2023"
                        onChange={handleAllInputChange}
                        min={todayDate}
                      />
                    </div>
                    <div className="cs_height_42 cs_height_xl_25"></div>
                  </div>

                  {!isMobile ? (
                    <div className="col-lg-6 mb-3 light-inputs-wrapper">
                      <label className="form-label">
                        Contact Number <span className="asterisk">*</span>
                      </label>
                      <input
                        name="contact_number"
                        value={inputValues.contact_number}
                        type="text"
                        className="input-name form-control"
                        placeholder="Enter Contact Number"
                        onChange={handleContactNumber}
                        maxLength={14}
                        minLength={10}
                      />

                      <div className="cs_height_42 cs_height_xl_25"></div>
                    </div>
                  ) : null}

                  <div className="col-lg-6 mb-3 light-select-wrapper">
                    <label className="form-label">
                      Preferred Time <span className="asterisk">*</span>
                    </label>
                    <Select
                      className="appointment_form_select"
                      value={
                        displayedValue !== null
                          ? { value: shift, label: displayedValue }
                          : null
                      }
                      options={shiftOptions}
                      onChange={handleShiftChange}
                      placeholder={
                        inputValues?.appointment_date
                          ? "Select Shift"
                          : "Please Select Date First"
                      }
                    />
                    <div className="cs_height_42 cs_height_xl_25"></div>
                  </div>


                  {/* Hospital Dropdown */}
                  {hospitals.length > 1 && (
                    <div className="col-lg-6 mb-3">
                      <div className="light-inputs-wrapper">
                        <label className="form-label">Email</label>
                        <input
                          name="email"
                          value={inputValues.email}
                          type="email"
                          className="input-name form-control"
                          placeholder="Enter your email"
                          onChange={handleAllInputChange}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>
                      </div>
                      <div className="light-select-wrapper">
                        <label className="form-label">
                          Hospital/Clinic <span className="asterisk">*</span>
                        </label>
                        <Select
                          className="appointment_form_select"
                          value={selectedHospital}
                          options={hospitals.map(hospital => ({
                            label: hospital?.info?.title,
                            value: hospital
                          }))}
                          onChange={handleHospitalChange}
                          placeholder="Select Hospital"
                          menuPortalTarget={document.body} // dropdown ko body me render karega
                          styles={{
                            menuPortal: base => ({ ...base, zIndex: 9999 }), // upar laane ke liye z-index
                          }}
                        />
                        <div className="cs_height_42 cs_height_xl_25"></div>


                      </div>

                    </div>
                  )}



                  <div className="col-lg-6 appointment-textarea mb-3 light-inputs-wrapper">
                    <label className="form-label">Remarks</label>
                    <textarea
                      rows={6}
                      name="remarks"
                      value={inputValues.remarks}
                      type="number"
                      className="input-name form-control"
                      placeholder="Write Your remarks here"
                      onChange={handleAllInputChange}
                    ></textarea>
                    <div className="cs_height_42 cs_height_xl_25"></div>
                  </div>


                  {/* <div className="col-lg-6 mb-3 light-inputs-wrapper">
                    <label className="form-label">Age</label>
                    <input
                      name="age"
                      value={inputValues.age}
                      type="number"
                      className="input-name form-control"
                      placeholder="Enter Age"
                      onChange={handleAllInputChange}
                    />
                    <div className="cs_height_42 cs_height_xl_25"></div>
                  </div> */}

                  <div className="col-lg-6 appointment_form_capcha mb-3 light-inputs-wrapper">
                    <label className="form-label">Captcha</label>
                    <Captcha
                      captcha={captcha}
                      inputCaptcha={input_captcha}
                      textColorClass={textColorClass}
                      checkCaptcha={check_captcha}
                      handleInputChange={handleInputChange}
                    />
                  </div>



                  <div className="col-lg-6 mb-3">
                    <div className="cs_height_18"></div>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent:"end" }}>
                     {/* {!isMobile ? (
                       <label className="form-label" style={{ visibility: "hidden" }}>Submit Button</label>
                     ) : null} */}
                      <button
                        type="submit"
                        className="btn btn-default"
                        style={{ width: "100px" }}
                        onClick={formSubmit}
                        disabled={appointmentisLoading}
                      >
                        <span>
                          {appointmentisLoading ? "Please Wait" : "Submit "}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}




        <FooterWrapper />
      </div>
    </div>
  );
}

export default AppointmentDoctor;